import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "demand-day-cutoff__icon" };
const _hoisted_3 = { class: "demand-day-cutoff__text" };
const _hoisted_4 = { class: "demand-day-cutoff__time" };
import { computed } from "vue";
import moment from "moment";
import Icon from '@astina/paloma-common-ui/src/components/Icon.vue';
import ClockIcon from '@astina/paloma-common-ui/src/components/ClockIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandDayCutoff',
    props: {
        date: {},
        imminent: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const dateFormatted = computed(() => {
            return moment(props.date).format('DD.MM. HH:mm');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "demand-day-cutoff",
                title: _ctx.$dateTime(__props.date)
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (__props.imminent)
                        ? (_openBlock(), _createBlock(Icon, {
                            key: 0,
                            name: "alarm-clock"
                        }))
                        : (_openBlock(), _createBlock(ClockIcon, {
                            key: 1,
                            date: __props.date
                        }, null, 8, ["date"]))
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(dateFormatted.value), 1)
                ])
            ], 8, _hoisted_1));
        };
    }
});
